import { Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Snackbar } from 'src/components/snackbar';
import { PATHS } from 'src/constants/paths';
import { useUpdateSyncLocations } from 'src/hooks';
import { lang } from 'src/utils';

import { SimpleDialog } from '../simpleDialog';
import { SyncLocationsModalProps } from './SyncLocationsModal.interface';

export const SyncLocationsModal = (props: SyncLocationsModalProps) => {
  const updateSyncLocations = useUpdateSyncLocations();
  const navigate = useNavigate();

  const onClickedConfirm = async () => {
    const {
      numberOfAddedLocations,
      numberOfDeletedLocations,
      numberOfUpdatedLocations,
    } = await updateSyncLocations.mutateAsync();

    const actions = [
      { count: numberOfAddedLocations, verb: 'added' },
      { count: numberOfUpdatedLocations, verb: 'updated' },
      { count: numberOfDeletedLocations, verb: 'deleted' },
    ];

    const messages = actions
      .filter(({ count }) => count > 0)
      .map(({ count, verb }) => lang.syncActionMessage(count, verb));

    if (messages.length === 0) {
      Snackbar.success(
        <Typography component="span">
          {lang.noLocationChangesToSync}
        </Typography>,
      );
    } else {
      const content = messages.join('\n');

      Snackbar.success(
        <Typography component="span" sx={{ whiteSpace: 'pre-line' }}>
          {content}
          <br />
          <Link
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              content.includes('added')
                ? navigate(PATHS.UNASSIGNED_LOCATIONS)
                : navigate(PATHS.LOCATIONS);
            }}>
            {lang.previewLocations}
          </Link>
        </Typography>,
      );
    }

    props.onClose();
  };

  return (
    <SimpleDialog
      onClickCancel={!updateSyncLocations.isLoading ? props.onClose : () => {}}
      onClickConfirm={onClickedConfirm}
      onClose={!updateSyncLocations.isLoading ? props.onClose : () => {}}
      open={props.open}
      title={lang.importLocationsModal.title}
      subTitle={lang.importLocationsModal.subTitle}
      cancelText={lang.cancel}
      confirmText={lang.save}
      isLoading={updateSyncLocations.isLoading}
    />
  );
};
